<template>
  <div>
    <div class="details-title">{{ title }}</div>
    <div class="card card-body card-account bg-light">
      <div class="row">
        <div class="col-md-8">
          {{ accountData.full_name }}
          <br/>
          {{ accountData.phone }}
        </div>
        <div class="col-md-5 text-right">
          <div @click="$bvModal.show('personal-details-modal')" class="link">Wijzig</div>
        </div>
      </div>
    </div>

    <b-modal ref="personal-details-modal" id="personal-details-modal" footer-class="modal-footer modal-save-details" centered>
      <template slot="modal-header">
        <h4 class="modal-title">{{ title }}</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          <form @submit.prevent="onSubmit">
            <div class="form-row">
              <div class="col-md-5">
                <label for="first-name" class="col-form-label">Voornaam</label>
                <input
                  id="first-name"
                  name="first-name"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.first_name.$error}"
                  v-model="first_name"
                  @blur="$v.first_name.$touch()"
                  placeholder="Voornaam"
                >
                <span v-if="$v.first_name.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. uw voornaam in.</strong>
                </span>
              </div>
              <div class="col-md-2">
                <label for="infix-name" class="col-form-label">Tussenv.</label>
                <input
                  id="infix-name"
                  name="infix-name"
                  type="text"
                  class="form-control"
                  v-model="infix_name"
                  placeholder="Tussenvoegsel"
                >
              </div>
              <div class="col-md-6">
                <label for="last-name" class="col-form-label">Achternaam</label>
                <input
                  id="last-name"
                  name="last-name"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.last_name.$error}"
                  v-model="last_name"
                  @blur="$v.last_name.$touch()"
                  placeholder="Achternaam"
                >
                <span v-if="$v.last_name.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. uw achternaam in.</strong>
                </span>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-13">
                <label for="phone" class="col-form-label">Telefoonnummer</label>
                <input
                  id="phone"
                  name="phone"
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': $v.phone.$error}"
                  v-model="phone"
                  @blur="$v.phone.$touch()"
                  placeholder="Telefoonnummer"
                >
                <span v-if="$v.phone.$error" class="invalid-feedback" role="alert">
                  <strong>Vul a.u.b. uw telefoonnummer in (zonder streepjes).</strong>
                </span>
              </div>
            </div>

            <fieldset class="form-group mt-2">
              <div class="row">
                <label class="col-form-label col-sm-3 pt-0">Geslacht</label>
                <div class="col-sm-10">
                  <div class="form-check form-check-inline">
                    <input v-model="gender" class="form-check-input" type="radio" name="gender" id="radio-male" value="0">
                    <label class="form-check-label gender-label" for="radio-male">Man</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input v-model="gender" class="form-check-input" type="radio" name="gender" id="radio-female" value="1">
                    <label class="form-check-label gender-label" for="radio-female">Vrouw</label>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>

        <div
          v-if="personalDetailsStatus"
          class="col-md-13 mt-2 alert"
          role="alert"
          :class="{ 'alert-success': personalDetailsStatus.success, 'alert-danger': !personalDetailsStatus.success }"
        >
          <strong>{{ personalDetailsStatus.message }}</strong>
        </div>
      </template>
      <template slot="modal-footer">
        <button
          @click="saveDetails"
          type="button"
          :disabled="$v.$invalid"
          :class="{'disabled cursor-not-allowed': $v.$invalid}"
          class="btn btn-oldevuuren btn-round w-100">Persoonsgegevens opslaan
          <font-awesome-icon class="font-awesome-icon" v-if="personalDetailsBusy" icon="spinner" spin/>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { minLength, required, numeric } from 'vuelidate/lib/validators'

  import { MUTATE_PERSONAL_DETAILS_STATUS, SAVE_PERSONAL_DETAILS } from '../../../store/types'

  export default {
    props: ['accountData'],
    data() {
      return {
        title: 'Persoonsgegevens',
        first_name: this.accountData.first_name,
        infix_name: this.accountData.infix_name,
        last_name: this.accountData.last_name,
        phone: this.accountData.phone,
        gender: this.accountData.gender
      }
    },
    validations: {
      first_name: {
        required,
        minLen: minLength(2)
      },
      last_name: {
        required,
        minLen: minLength(2)
      },
      phone: {
        required,
        numeric,
        minLen: minLength(10)
      }
    },
    computed: {
      personalDetailsStatus() {
        return this.$store.getters.personalDetailsStatus
      },
      personalDetailsBusy() {
        return this.$store.getters.personalDetailsBusy
      }
    },
    methods: {
      hideModal() {
        // hide
        this.$refs['personal-details-modal'].hide()
        // discard changes
        this.first_name = this.accountData.first_name
        this.infix_name = this.accountData.infix_name
        this.last_name = this.accountData.last_name
        this.phone = this.accountData.phone
        this.gender = this.accountData.gender
      },
      saveDetails() {
        const formData = {
          first_name: this.first_name,
          infix_name: this.infix_name,
          last_name: this.last_name,
          phone: this.phone,
          gender: this.gender
        }
        this.$store.dispatch(SAVE_PERSONAL_DETAILS, formData).then(() => {
          if (this.personalDetailsStatus.success) {
            this.$refs['personal-details-modal'].hide()
          }
        })
      }
    },
    mounted() {
      const store = this.$store
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        store.commit(MUTATE_PERSONAL_DETAILS_STATUS, null)
      })
    }
  }
</script>

<style lang="scss" scoped>
  legend {
    text-transform: uppercase;
  }

  .gender-label {
    text-transform: none;
  }

</style>
